"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getComponent;

function getComponent(childkey, children) {
  if (children) {
    if (children.length) {
      return children.filter(function (comp) {
        return comp.props.childkey === childkey;
      });
    }

    return children.props.childkey === childkey ? children : null;
  }

  return null;
}